import React, { useState, useEffect } from 'react';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import { Snackbar } from '@rmwc/snackbar';
import '@rmwc/snackbar/styles';
import './ImpExpPopup.css';
import { useFlexionStore } from './Stores';
import { getText } from './Helpers';

import Download from './assets/baseline_file_download_black_48dp.png';
import Upload from './assets/baseline_file_upload_black_48dp.png';
import ErrorImg from './assets/baseline_error_outline_white_48dp.png';

export default function ImpExpPopup(props) {
  const loadExportedState = useFlexionStore((state) => state.loadExportedState);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [text, settext] = useState(getText(Sprache));
  const [open, setopen] = useState(false);
  const [SnackMsg, setSnackMsg] = useState('');
  const { closePopupAfterSuccess } = props;

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  function ExportContext() {
    const myBlob = new Blob([JSON.stringify(useFlexionStore.getState())], { type: 'text/plain' });
    const url = URL.createObjectURL(myBlob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'Flexion.txt';
    anchor.click();
    URL.revokeObjectURL(url);
  }

  async function ReadImportFile(fileList) {
    if (fileList.length > 1) {
      setSnackMsg(text.Sidebar.ImportExportError1File);
      setopen(true);
      return;
    }
    const file = fileList[0];
    if (file.type && !file.type.startsWith('text/plain')) {
      setSnackMsg(text.Sidebar.ImportExportErrorTextFile);
      setopen(true);
      return;
    }

    const fileContent = await file.text();
    let LoadedState;
    try {
      LoadedState = JSON.parse(fileContent);
    } catch (err) {
      setSnackMsg(text.Sidebar.ImportExportErrorFile);
      setopen(true);
      return;
    }


    const seriesHelp = [];
    let data = [];
    await axios
      .get('https://app.rk-rose-krieger.com/api/flexion/newprofile')
      .then((response) => {
        response.data.forEach((i) => {
          if (!seriesHelp.includes(i.Series)) {
            seriesHelp.push(i.Series);
          }
          data.push(i);
        });
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          setSnackMsg(text.Sidebar.ImportExportErrorNetwork);
          setopen(true);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          setSnackMsg(text.Sidebar.ImportExportErrorNetwork);
          setopen(true);
        } else {
          // Something happened in setting up the request that triggered an Error
          setSnackMsg(`${text.Sidebar.ImportExportErrorNetwork}\n${error.message}`);
          setopen(true);
        }
        data = LoadedState.Profiles;
      });
    const oldDummys = LoadedState.Profiles.filter((p) => p.Series === 'Dummy');
    LoadedState.Profiles = data.concat(oldDummys);

    const ind = LoadedState.Profiles.findIndex(
      (p) => p.Description === LoadedState.ProfileDesc.label
    );
    if (ind === -1 && LoadedState.ProfileDesc !== '') {
      setSnackMsg(text.Sidebar.ImportExportErrorProfile);
      setopen(true);
      return;
    }

    if (oldDummys.length > 0) {
      seriesHelp.push('Dummy');
      LoadedState.Serie = seriesHelp;
    }

    loadExportedState(LoadedState);

    closePopupAfterSuccess();
  }

  return (
    <div>
      <h2>Import/Export</h2>
      <div className='ImpExpContainer'>
        <Dropzone onDrop={(acceptedFiles) => ReadImportFile(acceptedFiles)}>
          {({ getRootProps, getInputProps }) => (
            <section className='Dropzone'>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <img src={Upload} alt='Upload Flexion File' className='DownUpLogos' />
                <p>{text.Sidebar.ImportExportUpload}</p>
              </div>
            </section>
          )}
        </Dropzone>
        <div onClick={() => ExportContext()} className='ExportButton'>
          <img src={Download} alt='Download Flexion File' className='DownUpLogos' />
          <p>{text.Sidebar.ImportExportDownload}</p>
        </div>
      </div>
      <Snackbar open={open} onClose={() => setopen(false)} message={SnackMsg} icon={ErrorImg} />
    </div>
  );
}
